import { CircleHelpIcon } from 'lucide-react';
import * as React from 'react';
import { Button, type ButtonProps } from '../../../components/ui/button.tsx';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../components/ui/tooltip.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { cn } from '../../../lib/utils.ts';

export type IntercomLauncherProps = {
    expanded?: boolean;
    className?: string;
    variant?: ButtonProps['variant'];
};

const IntercomLauncher = React.forwardRef<HTMLButtonElement, IntercomLauncherProps>(
    ({ expanded = true, className = '', variant = 'ghost' }, ref) => {
        const { t } = useLocale('common');

        const openIntercom = () => {
            if (typeof window !== 'undefined' && window.Intercom) {
                window.Intercom('show');
            }
        };

        if (expanded) {
            return (
                <Button
                    ref={ref}
                    className={cn('w-full justify-start text-neutral-950', className)}
                    variant={variant}
                    onClick={openIntercom}
                    leftIcon={CircleHelpIcon}
                >
                    <span className="font-normal">{t('support__button')}</span>
                </Button>
            );
        }

        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        ref={ref}
                        variant={variant}
                        size="icon-s"
                        onClick={openIntercom}
                        icon={CircleHelpIcon}
                    />
                </TooltipTrigger>
                <TooltipContent side="right">{t('support__button')}</TooltipContent>
            </Tooltip>
        );
    },
);
IntercomLauncher.displayName = 'IntercomLauncher';

export { IntercomLauncher };
